// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
var _HomeTwoTone = /*#__PURE__*/ _interop_require_default(require("@ant-design/icons-svg/lib/asn/HomeTwoTone"));
var _AntdIcon = /*#__PURE__*/ _interop_require_default(require("../components/AntdIcon"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var HomeTwoTone = function(props, ref) {
    return /*#__PURE__*/ _react.createElement(_AntdIcon.default, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        icon: _HomeTwoTone.default
    }));
};
/**![home](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMi4xIDE3Mi42bC0zNzAgMzY5LjdoOTZWODY4SDM5MlY2NDBjMC0yMi4xIDE3LjktNDAgNDAtNDBoMTYwYzIyLjEgMCA0MCAxNy45IDQwIDQwdjIyOGgxNTMuOVY1NDIuM0g4ODJMNTM1LjIgMTk1LjdsLTIzLjEtMjMuMXptNDM0LjUgNDIyLjljLTYgNi0xMy4xIDEwLjgtMjAuOCAxMy45IDcuNy0zLjIgMTQuOC03LjkgMjAuOC0xMy45em0tODg3LTM0LjdjNSAzMC4zIDMxLjQgNTMuNSA2My4xIDUzLjVoLjljLTMxLjkgMC01OC45LTIzLTY0LTUzLjV6bS0uOS0xMC41di0xLjkgMS45em0uMS0yLjZjLjEtMy4xLjUtNi4xIDEtOS4xLS42IDIuOS0uOSA2LTEgOS4xeiIgZmlsbD0iI2U2ZjRmZiIgLz48cGF0aCBkPSJNOTUxIDUxMGMwLS4xLS4xLS4xLS4xLS4ybC0xLjgtMi4xYy0uMS0uMS0uMi0uMy0uNC0uNC0uNy0uOC0xLjUtMS42LTIuMi0yLjRMNTYwLjEgMTE4LjhsLTI1LjktMjUuOWEzMS41IDMxLjUgMCAwMC00NC40IDBMNzcuNSA1MDVhNjMuNiA2My42IDAgMDAtMTYgMjYuNmwtLjYgMi4xLS4zIDEuMS0uMyAxLjJjLS4yLjctLjMgMS40LS40IDIuMSAwIC4xIDAgLjMtLjEuNC0uNiAzLS45IDYtMSA5LjF2My4zYzAgLjUgMCAxIC4xIDEuNSAwIC41IDAgLjkuMSAxLjQgMCAuNS4xIDEgLjEgMS41IDAgLjYuMSAxLjIuMiAxLjggMCAuMy4xLjYuMS45bC4zIDIuNXYuMWM1LjEgMzAuNSAzMi4yIDUzLjUgNjQgNTMuNWg0Mi41Vjk0MGg2OTEuN1Y2MTQuM2g0My40YzguNiAwIDE2LjktMS43IDI0LjUtNC45czE0LjctNy45IDIwLjgtMTMuOWE2My42IDYzLjYgMCAwMDE4LjctNDUuM2MwLTE0LjctNS0yOC44LTE0LjMtNDAuMnpNNTY4IDg2OEg0NTZWNjY0aDExMnYyMDR6bTIxNy45LTMyNS43Vjg2OEg2MzJWNjQwYzAtMjIuMS0xNy45LTQwLTQwLTQwSDQzMmMtMjIuMSAwLTQwIDE3LjktNDAgNDB2MjI4SDIzOC4xVjU0Mi4zaC05NmwzNzAtMzY5LjcgMjMuMSAyMy4xTDg4MiA1NDIuM2gtOTYuMXoiIGZpbGw9IiMxNjc3ZmYiIC8+PC9zdmc+) */ var RefIcon = /*#__PURE__*/ _react.forwardRef(HomeTwoTone);
if (process.env.NODE_ENV !== 'production') {
    RefIcon.displayName = 'HomeTwoTone';
}
var _default = RefIcon;
